import React from 'react';
import { Slide } from "react-reveal";
import bull from "../../assets/images/icons/bull.svg";
import eye from "../../assets/images/icons/eye.svg";

const Mission = () => {
    return (
      <Slide top>
        <div className="mission-side">
          <div className="mission-item">
            <img src={bull} alt="Mission" />
            <div>
              <h2>Mission</h2>
              <p>
                “JMSTONE LOGISTICS LIMITED, aims to deliver superior engineering
                and geosynthetic installation services with unwavering
                dedication to quality, safety, and environmental
                responsibility”
              </p>
            </div>
          </div>
          <div className="mission-item">
            <img src={eye} alt="Vision" />
            <div>
              <h2>Vision</h2>
              <p>
                “To be the leading geosynthetics solutions provider in Uganda
                and East Africa, driving infrastructure innovation, and
                environmental sustainability.”
              </p>
            </div>
          </div>
        </div>
      </Slide>
    );
}
 
export default Mission;